/**
 * Scale down the button when a click is triggered
 * @param ev Button mouse down event
 */
export const handleMouseDownEvent = ev => {
  ev.target.style.transform = "scale(.94)"
}

/**
 * Scale up the button when a mouseup is triggered
 * @param ev Button mouse up event
 */
export const handleMouseUpEvent = ev => {
  ev.target.style.transform = "scale(1)"
}
